<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-9 mx-auto">
          <div
            class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--10 bg-color--light--1"
          >
            <div class="container">
              <div class="row">
                <div
                  class="col-12 mx-auto color--white text-center mb-4 mb-lg-5"
                >
                  <h4 class="mb-1" v-if="!isCustomer">
                    انتخاب حد اعتبار
                  </h4>
                  <h4 class="mb-1" v-if="isCustomer">
                    ویرایش حد اعتبار
                  </h4>
                </div>
              </div>
              <div class="row">
                <p class="font-size--8">
                  حد اعتبار، حداکثر میزان تسهیلات دریافتی توسط مشتری است.
                </p>
                <p class="font-size--8">
                {{$t("setLevel.description")}}
                </p>
              </div>
              <br />
              <br />
              <div class="row">
                <h6>حد اعتبار</h6>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12 font-size--15">
                  <form class="form">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        value="1"
                        v-model="level"
                        checked
                      />
                      <label class="form-check-label" for="exampleRadios1">
                       {{$t("setLevel.level1")}}
                      </label>
                      <!-- <small
                        id="passwordHelpBlock"
                        class="form-text text-danger"
                        v-show="level == 1"
                      >
                        بدون نیاز به ضامن
                      </small> -->
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios2"
                        value="2"
                        v-model="level"
                      />
                      <label class="form-check-label" for="exampleRadios2">
                        {{$t("setLevel.level2")}}
                      </label>
                      <!-- <small
                        id="passwordHelpBlock"
                        class="form-text text-danger"
                        v-show="level == 2"
                      >
                        نیاز به یک ضامن
                      </small> -->
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios3"
                        value="3"
                        v-model="level"
                      />
                      <label class="form-check-label" for="exampleRadios3">
                      {{$t("setLevel.level3")}}
                      </label>
                      <!-- <small
                        id="passwordHelpBlock"
                        class="form-text text-danger"
                        v-show="level == 3"
                      >
                        نیاز به دو ضامن
                      </small> -->
                    </div>
                    <br />
                    <br />
                    <div
                      class="d-flex justify-content-between align-items-center flex-column"
                    >
                      <button
                        class="btn btn-bg--primary btn-size--md btn-hover--3d align-center"
                        type="submit"
                        @click.prevent="setLevel"
                      >
                        <span class="btn__text" v-if="!isCustomer">ثبت</span>
                        <span class="btn__text" v-if="isCustomer">ویرایش</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vuejs-noty/dist/vuejs-noty.css";
export default {
  data() {
    return {
      level: "",
      create_customer: false,
    };
  },
  mounted() {
    this.createCostumer();
    this.getCustomerData();
  },
  computed: {
    isCustomer() {
      return this.$store.getters.isCustomer;
    },
  },
  methods: {
    createCostumer() {
      if (!this.isCustomer) {
        this.create_customer = true;
        this.$store
          .dispatch("creatCostumer")
          .then((resp) => {
            console.log(resp);
            // .$store.commit("setFirstName", resp.body.user.first_name);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getCustomerData() {
      if (this.isCustomer) {
        let load = this.$loading.show();
        this.$store
          .dispatch("getCustomerData")
          .then((response) => {
            console.log("response: ", response);

            this.level = response.body.level;
            load.hide();
          })
          .catch((err) => {
            console.log("err:  ", err);
            load.hide();
          });
      }
    },
    setLevel() {
      let level = this.level;
      if (this.create_customer) {
        let load = this.$loading.show();
        this.$store
          .dispatch("updateCostumer", { level })
          .then((resp) => {
            console.log(resp);
            load.hide();

            this.$router.push("/customer/customer-data");
          })
          .catch((err) => {
            load.hide();
            console.log(err);
          });
      } else {
        this.$swal({
          theme: "Bootstrap 4",
          icon: "error",
          title: "هشدار",
          text:
            "در صورت ویرایش اطلاعات، وضعیت کاربری شما به <<درحال بررسی>> تغییر خواهد کرد و دوباره باید منتظر تایید اطلاعات باشید",
          showCancelButton: true,
          confirmButtonText: "تایید",
          cancelButtonText: "انصراف",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.value) {
            let load = this.$loading.show();
            this.$store
              .dispatch("updateCostumer", { level })
              .then((resp) => {
                console.log(resp);
                load.hide();

                this.$noty.success("حد اعتبار با موفقیت تغییر یافت");
                this.$router.push("/customer");
              })
              .catch((err) => {
                load.hide();
                console.log(err);
                this.$noty.error(err.body.Error);
              });
          }
        });
      }
    },
  },
};
</script>
